<template>
  <div class="com-file">
    <div type="button" class="btn">
      {{ title }}
      <input
        :id="name"
        ref="input"
        type="file"
        :name="name"
        accept="image/png,image/jpeg,image/jpg"
        @change="onChange"
      />
    </div>
    <img v-show="show" ref="preview" class="pic" :src="src" height="auto" />
  </div>
</template>

<script>
export default {
  name: 'ComFile',
  props: {
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    maxSize: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      src: this.img,
      show: false
    }
  },
  watch: {
    img(val) {
      if (val) {
        this.src = val
      }
    }
  },
  mounted() {
    this.onShow()
  },
  methods: {
    onShow() {
      setTimeout(() => {
        if ('FileReader' in window) {
          if (this.src) {
            this.show = true
          }
        } else if (this.$refs.preview.style.filter) {
          this.show = true
        }
      }, 2000)
    },
    onChange() {
      const inputDom = this.$refs.input
      const previewDom = this.$refs.preview
      const image = new Image()
      let reader, file, path

      if (inputDom.files) {
        file = inputDom.files[0]
        if (!file) return

        if (!/^image\/(png|jpeg|jpg)$/.test(file.type)) {
          inputDom.value = ''
          this.$emit('error', this.name, `已过滤掉格式不正确的图片文件`)
          return
        }

        if (file.size > this.maxSize * 1024 * 1024) {
          inputDom.value = ''
          this.$emit('error', this.name, `已过滤掉大于${this.maxSize}MB的图片文件`)
          return
        }

        reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          image.onload = () => {
            // const width = image.width
            // const height = image.height

            // if(width > this.maxWidth || height > this.height) {
            //   this.$emit('error', {field: this.name, message: `请选择尺寸为${this.maxWidth}px * ${this.maxHeight}px以内以内的图片`})
            //   return
            // }

            this.src = reader.result
            this.onShow()
          }

          image.src = reader.result
        }

        this.$emit('change', this.name, file)
      } else {
        inputDom.select()
        path = document.selection.createRange().text

        if (!/\.(png|jpeg|jpg)$/.test(path)) {
          inputDom.value = ''
          this.$emit('error', this.name, `已过滤掉格式不正确的图片文件`)
          return
        }

        image.src = path
        image.onload = () => {
          if (image.fileSize > this.maxSize * 1024 * 1024) {
            inputDom.value = ''
            this.$emit('error', this.name, `已过滤掉大于${this.maxSize}MB的图片文件`)
            return
          }

          previewDom.src = ''
          // 使用滤镜效果
          previewDom.style.filter = `progid:DXImageTransform.Microsoft.AlphaImageLoader(enabled="true",sizingMethod="scale",src="${path}")`
          this.onShow()
        }

        this.$emit('change', this.name, true)
      }
    }
  }
}
</script>

<style lang="postcss">
.com-file {
  display: inline-block;
  vertical-align: top;

  .btn {
    display: block;
    position: relative;
    height: 32px;
    width: 70px;
    padding: 0 10px;
    font-size: 12px;
    color: #fff;
    background-color: #2d8cf0;
    border: none;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;

    input {
      font-size: 100px; /* 增大不同浏览器的可点击区域 */
      opacity: 0; /* 实现的关键点 */
      /* filter:alpha(opacity=0);兼容IE */
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      cursor: pointer;
      z-index: 2;
    }
  }

  .pic {
    display: block;
    width: 160px;
    margin-top: 10px;
  }
}
</style>
